import { PDFLayout } from "ui/components/PDF";
import { View } from "@react-pdf/renderer";
import PDFTableTitleRow from "components/PDF/Table/TableTitleRow";
import PDFTableRow from "components/PDF/Table/TableRow";
import colors from "core/resources/theme/colors";
import { CategoriaFinanceiraItem } from "features/condominio/hooks/useListFinancialCategory";
import useExportarPDFPlanoContasColumns from "./components/ItemTable/hooks/useExportarPDFPlanoContasColumns";
import { planifyCategoriasFinanceiras } from "../util/helper";

interface PDFPlanoContasProps {
  data?: CategoriaFinanceiraItem[];
  includeDocumentWrapper?: boolean;
  tenant?: string;
  logo?: string;
}

function PDFPlanoContas({
  data = [],
  includeDocumentWrapper = true,
  tenant = "",
  logo = "",
}: PDFPlanoContasProps) {
  const items = planifyCategoriasFinanceiras(data);
  const columns = useExportarPDFPlanoContasColumns();

  return (
    <PDFLayout
      fontSize={8}
      orientation="landscape"
      includeDocument={includeDocumentWrapper}
      headerProps={{
        logo,
        tenant,
        title: `Plano de Contas`,
        cards: [
          {
            title: "Total de Categorias",
            value: `${items.length}`,
          },
          {
            title: "Categorias ativas",
            value: `${items.filter((item) => item.ativo).length}`,
          },
          {
            title: "Categorias inativas",
            value: `${items.filter((item) => !item.ativo).length}`,
          },
        ],
      }}
    >
      <View>
        <PDFTableTitleRow columns={columns} />
      </View>
      {items.map((item, index) => (
        <View
          key={item.id}
          style={{ marginBottom: index < items.length - 1 ? 8 : 6 }}
        >
          <View>
            <PDFTableRow
              key={index}
              backgroundColor={index % 2 === 0 ? colors.white : colors.black100}
              item={item}
              columns={columns}
            />
          </View>
        </View>
      ))}
    </PDFLayout>
  );
}

export default PDFPlanoContas;
